import React from 'react';
import { connect } from 'react-redux';
import { isDirty } from 'redux-form';

import MODAL from 'components/Shared/Modals';
import { showModal } from 'modules/modal';

// HOC that provides a cancel confirmation for panels that have been changed
const withCancel = ({ form, dispatches }) => (PanelComponent) => {
    class DiscardPanel extends React.Component {
        onCancel = () => {
            const { dispatch, isDirty, onClose } = this.props;

            if (isDirty) {
                dispatch(showModal(MODAL.CONFIRM_PANEL_CLOSE, { dispatches }));
            } else {
                if (dispatches) {
                    dispatches.forEach((action) => dispatch(action));
                }
                if (onClose) {
                    onClose();
                }
            }
        };

        render() {
            return <PanelComponent onCancel={this.onCancel} {...this.props} />;
        }
    }

    const mapStateToProps = (state) => ({
        isDirty: isDirty(form)(state),
    });

    return connect(mapStateToProps)(DiscardPanel);
};

export default withCancel;
